<template>
  <div class="back-link" @click="handleBackClick">
    <router-link :to="{ path: '/' }">
      <font-awesome-icon :icon="['fas', 'arrow-left']" />
      <span class="pl-1">Back</span>
    </router-link>
  </div>
</template>


<script>
import HomebaseMixpanelMixin from "@/mixins/HomebaseMixpanelMixin";

export default {
  name: "back-to-home-button",
  mixins: [HomebaseMixpanelMixin],
  methods: {
    handleBackClick() {
      this.trackBackButtonClick();
    },
  },
};
</script>

<style scoped>
a {
  font-family: artifaktElementBold;
}
a:hover {
  cursor: pointer;
  text-decoration: none !important;
}
</style>